import React, { useState } from "react"
import BarcodeScannerComponent from "react-webcam-barcode-scanner"
import { Input, Button, Card, Dimmer, Loader, Table } from "semantic-ui-react"
import { ukmApi } from "../config/apiUrls"
import { apiPost } from "../utils/apiConnector"
import { useTranslation } from "react-i18next"

const media = window.innerWidth > 600

const CameraPage = () => {
  const [usid, setUsid] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  const { t } = useTranslation()

  const handleSubmit = () => {
    setData([])
    setIsLoading(true)
    apiPost(ukmApi, JSON.stringify({ usid }))
      .onOk((res) => {
        setData(res.data.response.items)
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }

  return (
    <>
      <h2>{t("CameraPage")}</h2>
      <div style={{ display: usid ? "none" : "block" }}>
        <BarcodeScannerComponent
          width={media ? 400 : window.innerWidth - 60}
          height={media ? 400 : window.innerWidth - 60}
          onUpdate={(err, result) => {
            if (result) setUsid(result.text)
          }}
        />
        <p>{t("Not Found")}</p>
      </div>
      <div style={{ display: usid ? "block" : "none" }}>
        <div style={{ display: media ? "flex" : "block" }}>
          <div style={{ width: media ? "30%" : "100%", padding: 15 }}>
            <div>
              <Input value={usid} disabled size="huge" fluid />
            </div>
            <div
              style={{
                marginTop: 10,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button positive content={"Find"} onClick={handleSubmit} />
            </div>
          </div>
          <div style={{ width: media ? "70%" : "100%", padding: 15 }}>
            <Card fluid>
              <Card.Content>
                <Dimmer active={isLoading} inverted>
                  <Loader />
                </Dimmer>
                {data && data.length > 0 && (
                  <Table style={{ border: "0px solid red" }}>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Verification")}:</b>
                        </Table.Cell>
                        <Table.Cell>
                          {data[0].isVerified ? (
                            <span>{t("Verification passed")}:</span>
                          ) : (
                            <span>{t("Verification not passed")}:</span>
                          )}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Organization")}:</b>
                        </Table.Cell>
                        <Table.Cell>{data[0].organization}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Product group")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].productGroup}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Product name")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].productName}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Region")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].productName}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Series")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].series}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Status")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].status}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("Volume")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].volume}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("stampProducedDate")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].stampProducedDate}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <b>{t("stampReceivedDate")}: </b>
                        </Table.Cell>
                        <Table.Cell>{data[0].stampReceivedDate}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                )}
              </Card.Content>
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}

export default CameraPage
